import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

const FIRST_NAME_MAX_LENGTH = 30;

export const FIRST_NAME_SCHEMA_FIELD_NAME = "firstName";

export const getFirstNameFormFieldSchema = (label = i18n("FirstNameFormField__LABEL")) =>
  yup.string().trim().required().max(FIRST_NAME_MAX_LENGTH).alphaSpace().label(label.toLowerCase());
